// extracted by mini-css-extract-plugin
export default {"dialog":"Walkme_dialog__4MhuJ"};